import { withInstall } from '@zoryn/utils'
import InputOtp from './src/input-otp.vue'

import type { SFCWithInstall } from '@zoryn/utils'

export const ZInputOtp: SFCWithInstall<typeof InputOtp> = withInstall(InputOtp)
export default ZInputOtp

export * from './src/input-otp'
export type { InputOtpInstance } from './src/instance'
